/**
 * 车辆列表(实时更新)
 */

import VehicleList from './VehicleList.vue';

export default VehicleList;